"use client";
import { useEffect, useState } from 'react';

export const useOnWindowResize = () => {
    const defaultWidth = typeof window !== "undefined" ? document?.body.offsetWidth : 0;
    const [bodyWidth, setBodyWidth] = useState(defaultWidth);
    const [bodyHeight, setBodyHeight] = useState(defaultWidth);
    useEffect(() => {
        const onResizeEvent = () => {
            setBodyWidth(document?.body.offsetWidth);
            setBodyHeight(document?.body.offsetHeight);
        };
        window.addEventListener('resize', onResizeEvent, true);

        return () => {
            window.removeEventListener('resize', onResizeEvent, true);
        };
    }, []);

    return [bodyWidth, bodyHeight];
};

function useRecalculateChatMeasures(): any[] {
  const [bodyWidth, bodyHeight] = useOnWindowResize();
  const [rootEl, setRootEl] = useState<HTMLElement>();
  const [headerEl, setHeaderEl] = useState<HTMLElement>();
  const [containerEl, setContainerEl] = useState<HTMLElement>();
  const [footerEl, setFooterEl] = useState<HTMLElement>();


  useEffect(() => {
    let interval: string | number | NodeJS.Timeout;
    if (!rootEl || !containerEl) {
      interval = setInterval(() => {
        const rootEl = document.getElementById('root');
        const headerEl = document.querySelector<HTMLElement>('.react-chatbot-kit-chat-header');
        const containerEl = document.querySelector<HTMLElement>('.react-chatbot-kit-chat-message-container');
        const footerEl = document.querySelector<HTMLElement>('.react-chatbot-kit-chat-input-container');
  
        setRootEl(rootEl)
        setHeaderEl(headerEl)
        setContainerEl(containerEl)
        setFooterEl(footerEl)
  
      }, 500)
    }

    return () => {
      clearInterval(interval)
    }  
  }, [rootEl, containerEl])

  useEffect(() => {
    if (!!rootEl && !!containerEl) {
      const parentEl = rootEl.parentElement;
      console.log('parentEl', parentEl.offsetHeight)
      console.log('containerEl', containerEl)
      const parentHeight = parentEl.offsetHeight;
      const headerHeight = headerEl ? headerEl?.offsetHeight : 0;
      const footerHeight = footerEl ? footerEl?.offsetHeight : 0;

      containerEl.style.height = (parentHeight - headerHeight - footerHeight)  + "px"
    }
  }, [bodyWidth, bodyHeight, containerEl, rootEl, headerEl, footerEl])

  return []
}

export default useRecalculateChatMeasures;



